export const ALL_DEPARTURE_TIMES = [
  'EARLY_MORNING',
  'MORNING',
  'AFTERNOON',
  'EVENING',
] as const;

export type DepartureTime = (typeof ALL_DEPARTURE_TIMES)[number];

export const DEPARTURE_TIME_BOUNDARIES_MINUTES: Record<
  DepartureTime,
  { start: number; end: number }
> = {
  EARLY_MORNING: { start: 0, end: 359 }, // 00:00 - 05:59
  MORNING: { start: 360, end: 719 }, // 06:00 - 11:59
  AFTERNOON: { start: 720, end: 1079 }, // 12:00 - 17:59
  EVENING: { start: 1080, end: 1439 }, // 18:00 - 23:59
};
